import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import ecanteenout from "../../Assets/Projects/ecanteen-out.png";
import ecommerceout from "../../Assets/Projects/ecommerce-out.png";
import hopeout from "../../Assets/Projects/hope-out.png";
import vcout from "../../Assets/Projects/videochat-out.png";
import adwyzorsout from "../../Assets/Projects/adwyzors-out.png";
import Box from '@mui/material/Box';
import './Project.css';
import { Link } from "react-router-dom";
import Navbar from "../Navbar";
import Footer from "../Footer";

function Projects() {
  return (
    <section>
      <Navbar />
      <Box className="filebox">
            <Row>
            <aside>
              <Col sm={1}>
                <Container className="strip" style={{ height: '100%' }}>
                
            <div direction="right" className="side-banner">
            <div className="marquee">
              <div className="marquee-content">
                PROJECTS.          PROJECTS.          PROJECTS.          PROJECTS.          PROJECTS.          PROJECTS.          PROJECTS.          PROJECTS.          PROJECTS.          PROJECTS.          PROJECTS.          PROJECTS.          PROJECTS.          PROJECTS.          PROJECTS.          PROJECTS.          PROJECTS.          PROJECTS.          PROJECTS.          
                </div>
                </div>
                </div>
                </Container>
              </Col>
              <Col sm={10} className="main-project-section" style={{ marginLeft: '70px' }}>
              <Container fluid className="project-section main-project-section">
          <Container  className="project-content">
                <Row style={{ justifyContent: "center" }}>
                  
                <Col md={4} className="project-card">
                    <Link to={'/project/ecommerce'} style={{textDecoration: 'none'}}>
                    <ProjectCard 
                      imgPath={ecommerceout}
                      isBlog={false}
                      title="Printing E-Commerce"
                      description="Designed a one-stop printing e-commerce shop."
                    />
                    </Link>
                  </Col>

                  <Col md={4} className="project-card">
                  <Link to={'/project/adwyzors'} style={{textDecoration: 'none'}}>
                    <ProjectCard
                      imgPath={adwyzorsout}
                      isBlog={false}
                      title="Adwyzors"
                      description="Re-designed LinkedIn to target only Chartered Accountants."
                    />
                  </Link>
                  </Col>
                  
                  <Col md={4} className="project-card">
                    <Link to={'/project/ecanteen'} style={{textDecoration: 'none'}}>
                    <ProjectCard 
                      imgPath={ecanteenout}
                      isBlog={false}
                      title="DJSCE E-Canteen"
                      description="Designed interface to improve the canteen ordering system."
                    />
                    </Link>
                  </Col>

                  
                
                  
                </Row>
                <Row style={{ justifyContent: "center", paddingBottom: "60px" }}>
                  <Col md={4} className="project-card">
                  <Link to={'/project/healthpredictor'} style={{textDecoration: 'none'}}>
                    <ProjectCard
                      imgPath={hopeout}
                      isBlog={false}
                      title="HoPE (Health Predictor)"
                      description="Designed and developed a system that helps users test certain ailments."
                    />
                  </Link>
                  </Col>

                  <Col md={4} className="project-card">
                  <Link to={'/project/videochat'} style={{textDecoration: 'none'}}>
                    <ProjectCard
                      imgPath={vcout}
                      isBlog={false}
                      title="Video Chat App for ASD"
                      description="Designed and created the frontend of a video chat service for ASD."
                    />
                  </Link>
                  </Col>
{/* 
                  <Col md={4} className="project-card">
                  <Link to={'/project/videochat'} style={{textDecoration: 'none'}}>
                    <ProjectCard
                      imgPath={vcout}
                      isBlog={false}
                      title="Video Chat App for ASD"
                      description="Designed and created the frontend of a video chat service for ASD."
                    />
                  </Link>
                  </Col> */}
                  
                </Row>
                </Container>
        </Container>
              </Col>
              </aside>
            </Row>
      <Footer />
      </Box>
    </section>
  );
}

export default Projects;
